var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('TokenDialog'),(_vm.isDevelop)?_c('MenuDevelop'):_vm._e(),_c('router-view',{attrs:{"name":"login"}}),_c('router-view',{attrs:{"name":"dashboard"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }